export default {
  routes: {
    home: "/",
    about_us: "/about-us",
    get_quote: "/get-quote",
    rates: "/rates",
    calculator: "/calculator",
    reverse: "/reverse",
    frequently_asked_questions: "/frequently-asked-questions",
    terms: "/terms-of-service",
    privacy: "/privacy-policy",
    howitworks: "/#how-it-works",
    howitworksid: "how-it-works",
    faq: "/faq"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/routes.js